import {Modal} from 'antd';
import iconClose from '@assets/icons/icon-close.png';
import MediaPreviewContent from '@/components/common/MediaPreviewModal';
import type {MediaPreviewConfig} from '@/components/common/MediaPreviewModal';
import modalStyles from '@/components/common/MediaPreviewModal/MediaPreviewModal.module.less';

let currentInstance: ReturnType<typeof Modal.info> | null = null;

/** 关闭媒体预览弹窗 */
function destroyMediaPreview(): void {
    if (currentInstance) {
        currentInstance.destroy();
        currentInstance = null;
    }
}

/**
 * 打开媒体预览弹窗（API 调用方式）
 */
export function showMediaPreview(config: MediaPreviewConfig): void {
    // 保证只有单个媒体预览弹窗
    destroyMediaPreview();

    currentInstance = Modal.info({
        centered: true,
        width: '100vw',
        mask: {
            closable: true,
        },
        closable: true,
        icon: null,
        title: null,
        okText: '',
        cancelText: '',
        footer: null,
        className: modalStyles.mediaPreviewModal,
        wrapClassName: modalStyles.mediaPreviewWrap,
        styles: {
            mask: {
                backdropFilter: 'blur(12px)',
                backgroundColor: 'var(--color-bg-mask-60)',
            },
        },
        closeIcon: <img src={iconClose} className={modalStyles.closeIcon} alt="关闭" />,
        content: <MediaPreviewContent {...config} onClose={destroyMediaPreview} />,
        afterClose: () => {
            currentInstance = null;
        },
    });
}

export {destroyMediaPreview};
